export default "__VITE_ASSET__DTjIqezN__"